import script from "./PersonalCardMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCardMulti.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCardMulti.vue?vue&type=style&index=0&id=3ebb26d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ebb26d4"]])

export default __exports__